import React from 'react';
import { Menu, Button, MenuItem, Icon } from '@mui/material';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import ReactPannellum from 'react-pannellum';
import { deleteWork } from '../utils/requests/workRequest';
import QuestionDialog from './QuestionDialog';

const imgWithClick = { cursor: 'pointer' };

const Photo = ({ index, onClick, photo, margin, direction, top, left }) => {
  const [isDelete, setIsDelete] = React.useState(false);
  const [toDelete, setToDelete] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);

  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const imgStyle = { margin };
  if (direction === 'column') {
    imgStyle.position = 'absolute';
    imgStyle.left = left;
    imgStyle.top = top;
  }

  const handleClick = (event) => {
    onClick(event, { photo, index });
  };

  const onMoreClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onOkClick = () => {
    setIsLoading(true);
    deleteWork(photo.id)
      .then((response) => {
        toast.success(response.data.message);
        photo.onDelete();
      })
      .finally(() => {
        setIsLoading(false);
      });
    handleClose();
  };

  const cancel = () => {
    setToDelete(false);
  };

  const deleteItem = () => {
    setToDelete(true);
  };

  const editItem = () => {
    if (photo.type === 2) navigate(`./${photo.id}/video`);
    else if (photo.type === 3) navigate(`./${photo.id}/3d`);
    else navigate(`./${photo.id}`);
  };

  const getPhoto = (photo) => {
    switch (photo.type) {
      case 2:
        return (
          <video {...photo} onClick={onClick ? handleClick : null} controls aria-hidden>
            <track kind="captions" />
            <source />
          </video>
        );
      case 3:
        return (
          <ReactPannellum
            sceneId="firstScene"
            id={`d_view_${photo.id}`}
            config={{ autoLoad: true, draggable: false, showControls: false, autoRotate: -2 }}
            imageSource={`${process.env.REACT_APP_API}works/${photo.id}/file`}
            style={{ width: photo.width, height: photo.height }}
          />
        );
      default:
        return <img {...photo} onClick={onClick ? handleClick : null} alt="img" aria-hidden />;
    }
  };

  const id = `photo-${photo.id}`;
  const btnId = `${id}-btn`;
  const style = onClick ? { ...imgStyle, ...imgWithClick } : imgStyle;

  return (
    <div
      style={{
        ...style,
        display: isDelete ? 'none' : 'block',
        opacity: isLoading ? 0.5 : 1
      }}
    >
      {toDelete && (
        <QuestionDialog
          buttons={[
            { action: () => onOkClick(), text: 'Yes' },
            { action: () => cancel(), text: 'Cancel' }
          ]}
          onClose={() => cancel()}
          title="Are your sure to delete ?"
          text="There is no way to recover deleted data !"
          isOpen={deleteItem}
        />
      )}
      {getPhoto(photo, style)}
      <Button
        id={btnId}
        arial-controls={open ? btnId : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={(e) => onMoreClick(e)}
        style={{ position: 'absolute', bottom: 0 }}
        variant="contained"
      >
        ººº
      </Button>
      <Menu
        id={btnId}
        aria-labelledby={btnId}
        anchorEl={anchorEl}
        open={open}
        onClose={() => handleClick}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
      >
        <MenuItem onClick={() => editItem()}>Edit Item</MenuItem>
        <MenuItem onClick={() => deleteItem()}>Delete item</MenuItem>
        <MenuItem onClick={() => handleClose()}>Cancel</MenuItem>
      </Menu>
    </div>
  );
};

export default Photo;
